import { AppEvent } from 'types/appEvent';
import { PartnerManager } from 'types/partnerManager';
import { createPartnerManager } from 'utils/partnerManagerUtils';
import { createReducer } from 'utils/reducer/reducerUtils';

export const reduceToNextPartnerManager = createReducer<
  PartnerManager,
  AppEvent
>((prev, event) => {
  switch (event.name) {
    case 'PartnerManager__PartnerCodeUpdated':
      if (prev.data !== null) {
        return {
          ...prev,
          data: {
            ...prev.data,
            partnerCode: event.nextPartnerCode,
          },
        };
      }

      return prev;
    case 'PartnersPage__TableItemClicked':
      return {
        ...prev,
        partnerId: event.partnerId,
        dataInvalidated: true,
      };
    case 'PartnerManager__DataRecieved':
      return {
        ...prev,
        data: event.data,
        dataInvalidated: false,
      };
    case 'PartnerManager__SreenChanged':
      return {
        ...prev,
        screen: event.nextScreen,
        dataInvalidated: true,
      };
    case 'PartnerManager__BlockChanged':
      return {
        ...prev,
        dataInvalidated: true,
      };
    case 'PartnerManager__Closed':
    case 'PartnersPage__ClientDetailsWillBeShown':
      return {
        ...createPartnerManager(),
      };
    default:
      return prev;
  }
});
